/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CraverBreadCrumb from '../share/CraverBreadCrumb';
import { commonResourceStyle } from '../../css/style';

import DisplayResources from '../crud/DisplayResources';
import { resourceFields } from '../../data/Constants';
import LoadingBar from '../share/LoadingBar';

const styles = commonResourceStyle();

class Customizations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredCustomizations: [],
      searchedTerm: null,
    };
  }

  componentDidMount = async () => {
    const { location } = this.props;
    await this.getCustomizationsResources();
    if (location.state && location.state.fromOptions) {
      this.filterCustomizations();
    }
  }

  componentDidUpdate = async (prevProps) => {
    const { apiToken, location } = this.props;
    if (prevProps.apiToken !== apiToken) {
      await this.getCustomizationsResources(true);
    }
    if (location.state && location.state.fromOptions) {
      location.state.fromOptions = false;
    }
  }

  getCustomizationsResources = async (forceFetch = false) => {
    const {
      customizations, actions, loading, apiToken,
    } = this.props;
    if (loading === false && !customizations || forceFetch) {
      await actions.getAllResources(apiToken, 'customizations');
    }
  }

  handleSearch = (term) => {
    this.setState({
      searchedTerm: term,
    });
  }

  handleClearSearch = () => {
    this.setState({
      searchedTerm: '',
    });
  }

  searchCustomizations = (term) => {
    const { customizations } = this.props;
    return term && customizations && customizations.filter((customization) => {
      const normalizedSearchTerm = term.toUpperCase();
      const normalizedName = customization.name.toUpperCase();
      const options = customization.options && customization.options.map(option => option.name);
      const normalizedOptions = options && options.join(',').toUpperCase();

      return normalizedName.includes(normalizedSearchTerm)
        || normalizedOptions.includes(normalizedSearchTerm);
    });
  }

  filterCustomizations = () => {
    const { customizations, location } = this.props;
    const customizationIds = location.state.modifierIds;
    const filteredCustomizations = customizations
      && customizations.filter(customization => customizationIds.includes(customization.id));
    return filteredCustomizations;
  }

  getCustomizations = () => {
    const { location, customizations } = this.props;
    const { searchedTerm } = this.state;
    const fromOptions = location.state && location.state.fromOptions;
    let filteredCustomizations;
    if (searchedTerm) {
      filteredCustomizations = this.searchCustomizations(searchedTerm);
    } else if (fromOptions) {
      filteredCustomizations = this.filterCustomizations();
    } else {
      filteredCustomizations = customizations;
    }
    return filteredCustomizations;
  }

  render() {
    const {
      actions, loading, apiToken, match,
    } = this.props;
    const { resource } = match.params;
    const optionsButton = [{ id: 1, btnTitle: 'options' }];
    const filteredCustomizations = this.getCustomizations();

    return (
      (loading === true)
        ? <LoadingBar />
        : (
          <div style={styles.container}>
            <div style={styles.resourceHeader}>
              <div style={styles.resourceName}>
                <Typography style={styles.resourceName}>Modifier Groups</Typography>
              </div>
              <div style={styles.breadcrumbContainer}>
                <CraverBreadCrumb resource='modifier groups' />
              </div>
            </div>
            <Paper style={styles.paper}>
              <DisplayResources
                data={filteredCustomizations}
                actions={actions}
                fieldNames={resourceFields.customizations}
                resourceName="customizations"
                buttonArray={optionsButton}
                apiToken={apiToken}
                handleSearch={this.handleSearch}
                handleClearSearch={this.handleClearSearch}
              />
            </Paper>
          </div>
        )
    );
  }
}

Customizations.propTypes = {
  loading: PropTypes.bool.isRequired,
  customizations: PropTypes.arrayOf(PropTypes.object),
  location: PropTypes.objectOf(PropTypes.any),
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

Customizations.defaultProps = {
  customizations: null,
  location: null,
};

export default withRouter(Customizations);
